<ion-content class="ion-padding">
  <div class="max-page-width">
    <ion-item lines="none" mode="ios" class="title-with-back-button">
      <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
        <ion-icon class="bp-arrow-left"></ion-icon>
      </ion-button>
      <ion-label class="ion-text-center ion-text-wrap">
        {{ 'notepad.notepad' | translate | uppercase }}
      </ion-label>
    </ion-item>

    <ng-container *ngIf="currentUser && currentUser.manager">      <ion-segment class="notepad" [(ngModel)]="currentSegment">
        <ion-segment-button value="user">
          <ion-label>
            {{ 'notepad.myComments' | translate | uppercase }}
          </ion-label>
        </ion-segment-button>
        <ng-container *ngIf="envNotePadWithAllUsers">
          <ion-segment-button value="allSubordinates">
            <ion-label>
              {{ 'notepad.employeesComments' | translate | uppercase }}
            </ion-label>
          </ion-segment-button>
        </ng-container>
        <ng-container *ngIf="!envNotePadWithAllUsers">
          <ion-segment-button value="subordinates">
            <ion-label>
              {{ 'notepad.avaliatedsComments' | translate | uppercase }}
            </ion-label>
          </ion-segment-button>
        </ng-container>
      </ion-segment>
    </ng-container>

    <ion-card class="reports-card" mode="ios" [ngSwitch]="currentSegment">
      <app-user-notes
        *ngSwitchCase="'user'"
        [notes]="notes"
        [currentUser]="currentUser"
        (reloadNotes)="loadNotes()"
      ></app-user-notes>

      <ng-container *ngIf="envNotePadWithAllUsers">
        <app-square-subordinates-notes
          #allSubordinates
          *ngSwitchCase="'allSubordinates'"
          [setSubordinateNotes]="allSubordinateNotes"
          [currentUser]="currentUser"
          [isAll]="false"
          (reloadNotes)="loadAllSubordinatesNotes()"
        ></app-square-subordinates-notes>
      </ng-container>

      <ng-container *ngIf="!envNotePadWithAllUsers">
        <app-subordinates-notes
          #subordinates
          *ngSwitchCase="'subordinates'"
          [setSubordinateNotes]="subordinateNotes"
          [currentUser]="currentUser"
          [isAll]="true"
          (reloadNotes)="loadSubordinatesNotes()"
        ></app-subordinates-notes>
      </ng-container>
    </ion-card>
  </div>
</ion-content>
